var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.034 36V21.218C28.034 9.81 35.496 2.078 46 0L47.99 4.302C43.126 6.136 40 11.578 40 16H48V36H28.034ZM0 36V21.218C0 9.81 7.496 2.078 18 0L19.992 4.302C15.126 6.136 12 11.578 12 16H19.966V36H0Z",
    fill: "#002942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIc);
export default __webpack_public_path__ + "static/media/quote-ic.71ee8ebb3ae24d7697cc4b9c3547bd1f.svg";
export { ForwardRef as ReactComponent };